<template>
  <div class="myCenterCommon__userContent__2fHEF">
    <div class="myCenterCommon__users_layout__title__3CoQ0">
      <h3>申请代理</h3>
      <span>请填写真实申请信息，以便管理员审核代理信息！</span>
    </div>
    <div class="userInfo__users_layout_form__HFPCL">
      <div class="userInfo__users_infoTitle__UKMBL">基本资料</div>
      <div class="userInfo__users_layout_form_item__35aDr">
        <div class="userInfo__users_layout_form_label__2V7le">真实姓名：</div>
        <div class="userInfo__users_layout_form_input__2D3z3">
          <input type="text" data-analytics="button" :value="$store.state.userInfo.realname" placeholder="请输入真实姓名" disabled class="index__Input__tY5CA" style="width: 450px; height: 40px" />
        </div>
      </div>

      <div class="userInfo__users_layout_form_item__35aDr">
        <div class="userInfo__users_layout_form_label__2V7le">联系方式：</div>
        <div class="userInfo__users_layout_form_input__2D3z3">
          <input type="text" data-analytics="button" v-model="info.mobile" placeholder="请输入您的联系方式" class="index__Input__tY5CA" style="width: 450px; height: 40px" />
        </div>
      </div>
      <div class="userInfo__users_layout_form_item__35aDr" style="height: 120px" v-if="false">
        <div class="userInfo__users_layout_form_label__2V7le">申请说明：</div>
        <div class="userInfo__users_layout_form_input__2D3z3">
        </div>
      </div>
      <div class="userInfo__users_layout_form_item__35aDr" style="height: auto" >
        <div class="userInfo__users_layout_form_label__2V7le">申请说明：</div>
        <div class="userInfo__users_layout_form_input__2D3z3">
          <!-- <input type="textarea" data-analytics="button" :rows="6" v-model="info.apply_info" placeholder="请输入申请说明"  /> -->
          <el-input type="textarea" :rows="6" v-model="info.apply_info" placeholder="请输入申请说明" style="width: 450px; height: 180px" resize="none" autocomplete="off"> </el-input>

          
        </div>
      </div>
      <button @click="shenqing" data-analytics="button" data-label="代理申请-保存" class="index__Button__It0J4 index__Button3__1Pn-Q " style="width: 190px; height: 40px; margin: 0px 0px 20px 72px">提交申请</button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'applyagent',
  data() {
    return { info: {} };
  },
  created() {
    let that = this;
  },
  methods: {
    shenqing() {
      let that = this;
      that.birthday = $('.ant-picker-input').html();
      let info = that.info;
      let regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!regExp.test(info.mobile)) {
        that.showTost(0, '请输入正确手机号');
        return;
      }

      if (!info.apply_info) {
        that.showTost(0, '请输入申请理由');
        return;
      }
      // that.close();

      that.showLoading();
      that.$apiFun
        .post('/api/applyagentdo', info)
        .then(res => {
          that.showTost(1, res.message);
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
     showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/Transfer_81ba8019.f1b60e17.css';

</style>



// WEBPACK FOOTER //
// src/components/mine/applyagent.vue